import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cep'})
export class CepPipe implements PipeTransform {

	transform(value: string) {
		if (value) {
			value = String(value);
			if (!value.includes('-')) {
				value = value.replace(/(\d{5})(\d{3})/g, '\$1\-\$2');
			}
		}
		return value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/cep.pipe.ts